import { CSSProperties, ReactNode } from 'react';

import { StyledArrowContainer, StyledArrowSpan } from './custom-arrows.style';

type CustomArrowProps = {
    icon: ReactNode;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
    currentSlide?: number;
    slideCount?: number;
    size?: number;
}

export const CustomArrow = ({ className, style, onClick, icon, size = 1.875 }: CustomArrowProps) => (
    <StyledArrowContainer
        $size={size}
        className={className}
        style={{ ...style }}
        onClick={onClick}
    >
        <StyledArrowSpan $size={size}>
            {icon}
        </StyledArrowSpan>
    </StyledArrowContainer>
);
